// extracted by mini-css-extract-plugin
export default {"buttonsContainer":"UserScreen_buttonsContainer__poy9a","button":"UserScreen_button__4IvSG"};